exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-text-link{display:block}adp-text-link a{font-family:ProximaNova-Semibold,Arial,Helvetica,sans-serif;font-size:14px;text-decoration:underline;color:#0e5061}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpTextLink/adpTextLink.less
// module id = 576
// module chunks = 0